import {
  Button,
  Upload,
  Form,
  DatePicker,
  Row,
  Col,
  Select,
  Input,
  AutoComplete,
  Radio,
  Spin,
  message,
} from "antd/lib";
import { PlusOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import axiosInPosp from "../../Redux/axios/AxiosInPosp";
import axiosInstance from "../../Redux/axios/AxiosInstance";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Previousinsurer } from "../../Redux/actions/NumLife";
import moment from "moment";

export default function MisPospForm() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const { RangePicker } = DatePicker;
  const { Option } = Select;
  const [RcfileList, setRcfileList] = useState([]);
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [spinLoad, setSpinLoad] = useState(false);
  const [ViewQuote, setViewQuote] = useState(false);
  const [MakeData, setMakeData] = useState([]);
  const [Makeoptions, setMakeoptions] = useState([]);
  const [bikemake, setBikeMake] = useState("");
  const [ModalData, setModalData] = useState([]);
  const [InsurerList, setInsurerList] = useState([]);
  const [gvalue, setValue] = useState("M");
  const [commSelect, setcommSelect] = useState("");
  const [SubProdSelect, setSubProSelect] = useState("");
  const [optionalMsg, setoptionalMsg] = useState("");
  const [vehicleNumber, setVehicleNumber] = useState("");
  const BASEURL = process.env.REACT_APP_UAT_BASE_URL;

  useEffect(() => {
    dispatch(Previousinsurer())
      .then((res) => {
        console.log("previous insurer", res);
        setInsurerList(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [ViewQuote]);
  useEffect(() => {
    axiosInPosp
      .get(`vehicle_masters?no_of_wheels=2`)
      .then((res) => {
        //console.log(res);
        const resp = res?.data?.makes;
        const makeData = resp?.map((item) => item);
        // console.log("resp", makeData);
        setMakeoptions(makeData);
        setMakeData(makeData);
      })
      .catch((err) => {
        //console.log(err);
      });
  }, []);
  const onSelectMake = (data) => {
    //console.log("onSelect", data);
    setBikeMake(data);
    form.setFieldsValue({
      bikeModel: "",
      bikeVarient: "",
    });
  };

  useEffect(() => {
    axiosInPosp
      .get(`vehicle_masters?no_of_wheels=2&make=${bikemake}`)
      .then((res) => {
        //console.log(res);
        const resp = res?.data?.models;
        //console.log(resp);
        const modelData = resp?.map((item) => item);
        // console.log("resp", modelData);
        // setOptions(modelData)
        setModalData(modelData);
      })
      .catch((err) => {
        console.log(err.response);
      });
  }, [bikemake]);
  const ModelChange = (e) => {
    console.log(e);
  };
  const props1 = {
    multiple: false,
    accept: "application/pdf, .jpg, .png",
    beforeUpload: (file) => {
      setRcfileList([...RcfileList, file]);
      return false;
    },
    onRemove: (file) => {
      const index = RcfileList.indexOf(file);
      const newFileList = RcfileList.slice();
      newFileList.splice(index, 1);
      setRcfileList(newFileList);
    },
    RcfileList,
  };
  const prefixSelector = (
    <Select
      style={{
        width: 70,
      }}
      defaultValue="+91"
    >
      <Option value="+91">+91</Option>
    </Select>
  );
  const handleInputChange = (e) => {
    const BikeReg = e.target.value.toUpperCase();
    // console.log("e.target.value", BikeReg);
    form.setFieldsValue({ reg_number: BikeReg });
    // e.target.value = BikeReg;
    console.log(BikeReg?.length);
    setVehicleNumber(BikeReg);
    if (BikeReg?.length >= 8) {
      setSpinLoad(true);
      axiosInstance
        .post("getVehicleDetails", {
          vehicleNumber: BikeReg,
        })
        .then((res) => {
          console.log(res);

          let bikeresult = res?.data?.data;
          console.log("bikeresult", bikeresult);
          form.setFieldsValue({
            bikeMake: bikeresult?.maker_model,
            bikeModel: bikeresult?.maker_description,
            customer_name: bikeresult?.owner_name,
            // policy_end_date: moment(bikeresult?.insurance_upto),
            // policy_number: bikeresult?.insurance_policy_number,
            // current_insurer: bikeresult?.insurance_company,
          });
          setSpinLoad(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          setSpinLoad(false);
        });
    }
  };
  const disabledDate = (current) => {
    const today = moment();
    const minDate = today.subtract(18, "years");

    return current.isAfter(minDate, "day");
  };
  const getDefaultPickerValue = () => {
    const today = moment();
    const minDate = today.subtract(18, "years");
    return minDate;
  };
  const onChangeRadio = (e) => {
    // setRadioCheck(e.target.checked)
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
    form.resetFields(["product", "sub_product"]);
    // setcommSelect('')
  };
  const onProductSelect = (e) => {
    console.log(e);
    setcommSelect(e);
    if (e === "COMMERCIAL") {
      form.resetFields(["sub_product"]);
      // setcommSelect('')
    }
  };
  const onSubProdSelect = (e) => {
    console.log(e);
    setSubProSelect(e);
    if (e === "New") {
      setoptionalMsg("(Vehicle Number is Optional.)");
    } else {
      setoptionalMsg("");
    }
  };
  const disabledPolicyStart = (current) => {
    const currentDate = moment();
    return current && current < currentDate.endOf("day");
  };
  const getDefaultExpPicker = () => {
    const today = moment();
    const minDate = today.add(1, "years");
    return minDate;
  };
  const onFinish = (values) => {
    console.log("valuesss", values);
    setSpinLoad(true);
    setLoading(true);
    let post = {
      product_type: values?.product,
      required_policy_type: values?.sub_product,
      firstName: values?.customer_name,
      customer_dob: values?.customer_dob,
      phonenumber: values?.customer_number,
      policy_start_date: moment(values?.policy_start_date).format("YYYY-MM-DD"),
      policy_end_date: moment(values?.policy_end_date).format("YYYY-MM-DD"),
      policy_number: values?.policy_number,
      current_insurer: values?.current_insurer,
      net_premium: values?.net_premium,
      total_premium: values?.total_premium,
      licensePlateNumber:
        values?.reg_number === undefined ? "" : values?.reg_number,
      make: values?.bikeMake === undefined ? "" : values?.bikeMake,
      model: values?.bikeModel === undefined ? "" : values?.bikeModel,
      current_ncb: values?.current_ncb,
      own_damage_premium:
        values?.own_damage_premium === undefined
          ? ""
          : values?.own_damage_premium,
      addon_premium:
        values?.addon_premium === undefined ? "" : values?.addon_premium,
      basic_tp_premium:
        values?.basic_tp_premium === undefined ? "" : values?.basic_tp_premium,
      cpa_premium: values?.cpa_premium === undefined ? "" : values?.cpa_premium,
      channel_name: values?.channel_name,
      insurer_user_code: values?.insurer_user_code,
      od_comm_percent: values?.od_comm_percent,
      tp_comm_percent: values?.tp_comm_percent,
      comm_percent: values?.comm_percent,
      payment_mode: values?.payment_mode,
      cheque_number: values?.cheque_number,
    };

    const formData = new FormData();
    Object.keys(post).forEach((key) => {
      formData.append(key, post[key]);
    });
    formData.append("policy_document", RcfileList[0]);
    axiosInPosp
      .post(`v1/posp/mises`, formData)
      .then((res) => {
        const { data } = res;
        console.log(data);
        //   setData(data?.data);
        setLoading(false);
        setSpinLoad(false);
        message.success("Policy Added Successfully");
        form.resetFields();
      })
      .catch((err) => {
        console.log(err?.response);
        setLoading(false);
        setSpinLoad(false);
      });
  };
  return (
    <>
      <section
        className="bg-light"
        style={{ minHeight: "calc(100vh - 50px)", padding: 20 }}
      >
        <Spin spinning={spinLoad}>
          <div className="row align-items-start justify-content-between">
            <div className="col-xl-12 col-lg-6 px-3 col-md-6 bike-info-quotebef">
              <div
                className="h6 text-blue py-3 text-center mb-0"
                style={{ fontSize: "20px", fontWeight: "700" }}
              >
                MIS Movement
              </div>
              <Form
                form={form}
                layout="vertical"
                style={{ width: "100%" }}
                requiredMark={false}
                onFinish={onFinish}
                // onFinishFailed={onFinishFailed}
              >
                <Radio.Group
                  className="d-flex row py-3"
                  onChange={onChangeRadio}
                  value={gvalue}
                >
                  <div className="col-xl-2 col-lg-2 col-sm-12 px-0">
                    <Radio.Button
                      value="M"
                      className={
                        gvalue === "M" ? `active-button-posp` : "posp-motor-rb"
                      }
                    >
                      <span>Motor</span>
                    </Radio.Button>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-sm-12 px-0">
                    <Radio.Button
                      value="N"
                      className={
                        gvalue === "N" ? `active-button-posp` : "posp-motor-rb"
                      }
                    >
                      <span>Non-Motor</span>
                    </Radio.Button>
                  </div>
                </Radio.Group>
                <Row gutter={24}>
                  {gvalue === "M" ? (
                    <>
                      <Col span={6}>
                        <Form.Item
                          name="product"
                          label="Product"
                          rules={[
                            {
                              required: true,
                              message: "Please select product type",
                            },
                          ]}
                          //initialValue={EngData?.agreementType}
                        >
                          <Select
                            placeholder="select product type"
                            onSelect={onProductSelect}
                            options={[
                              {
                                label: "TW",
                                value: "TWO WHEELER",
                              },
                              {
                                label: "PVT Car",
                                value: "PRIVATE CAR",
                              },
                              {
                                label: "Commercial",
                                value: "COMMERCIAL",
                              },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                    </>
                  ) : gvalue === "N" ? (
                    <>
                      <Col span={6}>
                        <Form.Item
                          name="product"
                          label="Product"
                          rules={[
                            {
                              required: true,
                              message: "Please select product type",
                            },
                          ]}
                          //initialValue={EngData?.agreementType}
                        >
                          <Select
                            placeholder="select product type"
                            onSelect={onProductSelect}
                            options={[
                              {
                                label: "Life",
                                value: "LIFE",
                              },
                              {
                                label: "Health",
                                value: "HEALTH",
                              },
                              {
                                label: "Travel",
                                value: "TRAVEL",
                              },
                              {
                                label: "Others",
                                value: "OTHERS",
                              },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                    </>
                  ) : null}
                  {gvalue === "M" ? (
                    <>
                      <Col span={6}>
                        <Form.Item
                          name="sub_product"
                          label="Classification"
                          rules={[
                            {
                              required: true,
                              message: "Please select classification type",
                            },
                          ]}
                        >
                          <Select
                            onSelect={onSubProdSelect}
                            placeholder="select classification type"
                            options={[
                              {
                                label: "New",
                                value: "New",
                              },
                              {
                                label: "Package",
                                value: "Comprehensive",
                              },
                              ...(commSelect !== "COMMERCIAL"
                                ? [
                                    {
                                      label: "SAOD",
                                      value: "Standalone own damage",
                                    },
                                  ]
                                : []),
                              {
                                label: "TP",
                                value: "Third party",
                              },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                    </>
                  ) : gvalue === "N" ? (
                    <>
                      <Col span={6}>
                        <Form.Item
                          name="sub_product"
                          label="Classification"
                          rules={[
                            {
                              required: true,
                              message: "Please select classification type",
                            },
                          ]}
                        >
                          <Select
                            // onSelect={onSubProdSelect}
                            placeholder="select classification type"
                            options={[
                              ...(commSelect === "LIFE"
                                ? [
                                    {
                                      label: "Term Life",
                                      value: "Term life",
                                    },
                                  ]
                                : []),
                              ...(commSelect === "HEALTH"
                                ? [
                                    {
                                      label: "Individual",
                                      value: "individual",
                                    },
                                    {
                                      label: "Family Floater",
                                      value: "family floater",
                                    },
                                  ]
                                : []),
                              ...(commSelect === "TRAVEL"
                                ? [
                                    {
                                      label: "Single Trip",
                                      value: "single trip",
                                    },
                                    {
                                      label: "Group Travel",
                                      value: "group travel",
                                    },
                                  ]
                                : []),
                              ...(commSelect === "OTHERS"
                                ? [
                                    {
                                      label: "SME",
                                      value: "SME",
                                    },
                                    {
                                      label: "Fire",
                                      value: "fire",
                                    },
                                    {
                                      label: "CAR",
                                      value: "CAR",
                                    },
                                    {
                                      label: "EAR",
                                      value: "EAR",
                                    },
                                    {
                                      label: "CPM",
                                      value: "CPM",
                                    },
                                  ]
                                : []),
                            ]}
                          />
                        </Form.Item>
                      </Col>
                    </>
                  ) : null}
                  {gvalue === "N" ? null : (
                    <Col span={6}>
                      <Form.Item
                        label="Vehicle Registration No."
                        name="reg_number"
                        rules={[
                          {
                            pattern: /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{3,4}$/,
                            message: "Invalid Vehicle No",
                          },
                          ...(SubProdSelect !== "New"
                            ? [{ required: true, message: "Enter Vehicle No" }]
                            : []),
                        ]}
                      >
                        <Input
                          onChange={handleInputChange}
                          placeholder="Enter Vehicle Number (eg. DL1SAB1234)"
                          value={vehicleNumber}
                        ></Input>
                        {SubProdSelect !== "New" ? null : (
                          <p className="mb-0" style={{ fontSize: "11px" }}>
                            {optionalMsg}
                          </p>
                        )}
                      </Form.Item>
                    </Col>
                  )}
                  {gvalue === "N" ? null : (
                    <>
                      <Col span={6}>
                        <Form.Item
                          name="bikeMake"
                          label="Select Make"
                          rules={[
                            {
                              required: true,
                              message: "Please Select Make",
                            },
                          ]}
                          // initialValue={vechicleData?.maker_description}
                        >
                          <AutoComplete
                            placeholder="Select Make"
                            showSearch
                            filterOption={(input, option) =>
                              option.label
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            options={MakeData?.map((p, index) => ({
                              key: index,
                              value: p,
                              label: p,
                            }))}
                            // onChange={(e)=>onSelectMake(e)}
                            onSelect={(e) => onSelectMake(e)}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="bikeModel"
                          label="Select Model"
                          rules={[
                            {
                              required: true,
                              message: "Please Select Model",
                            },
                          ]}
                          // initialValue={vechicleData?.maker_model}
                        >
                          <AutoComplete
                            placeholder="Select Model"
                            showSearch
                            filterOption={(input, option) =>
                              option.label
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            options={ModalData?.map((p, index) => ({
                              key: index,
                              value: p,
                              label: p,
                            }))}
                            // onChange={(e)=>ModelChange(e)}
                            onSelect={(e) => ModelChange(e)}
                          />
                        </Form.Item>
                      </Col>
                    </>
                  )}
                  <Col span={6}>
                    <Form.Item
                      label="Channel Name"
                      name="channel_name"
                      rules={[
                        {
                          required: true,
                          message: "please input Channel Name",
                        },
                      ]}
                      // initialValue={PospQuotePost?.firstName }
                    >
                      <Select
                        placeholder="Channel Name"
                        showSearch
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        // onChange={handleChange}
                        options={InsurerList?.map((p) => ({
                          key: p.id,
                          value: p.name,
                          label: p.name,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Insurer User Code"
                      name="insurer_user_code"
                      rules={[
                        {
                          required: true,
                          message: "please input Insurer User Code",
                        },
                      ]}
                      // initialValue={PospQuotePost?.firstName }
                    >
                      <Select
                        placeholder="Insurer User Code"
                        showSearch
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        // onChange={handleChange}
                        options={InsurerList?.map((p) => ({
                          key: p.id,
                          value: p.name,
                          label: p.name,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                  {gvalue === "N" ? null : (
                    <>
                      {SubProdSelect === "Third party" ? null : (
                        <Col span={6}>
                          <Form.Item
                            label="OD COMM %"
                            name="od_comm_percent"
                            rules={[
                              {
                                required: true,
                                message: "please input OD COMM",
                              },
                            ]}
                            // initialValue={PospQuotePost?.firstName }
                          >
                            <Input
                              style={{ width: "100%" }}
                              placeholder="OD COMM"
                            />
                          </Form.Item>
                        </Col>
                      )}
                      <Col span={6}>
                        <Form.Item
                          label="TP COMM %"
                          name="tp_comm_percent"
                          rules={[
                            {
                              required: true,
                              message: "please input TP COMM",
                            },
                          ]}
                          // initialValue={PospQuotePost?.firstName }
                        >
                          <Input
                            style={{ width: "100%" }}
                            placeholder="TP COMM"
                          />
                        </Form.Item>
                      </Col>
                    </>
                  )}
                  {gvalue === "N" ? (
                    <Col span={6}>
                      <Form.Item
                        label="COMM %"
                        name="comm_percent"
                        rules={[
                          {
                            required: true,
                            message: "please input COMM",
                          },
                        ]}
                        // initialValue={PospQuotePost?.firstName }
                      >
                        <Input style={{ width: "100%" }} placeholder="COMM" />
                      </Form.Item>
                    </Col>
                  ) : null}

                  <Col span={6}>
                    <Form.Item
                      label="Payment Mode"
                      name="payment_mode"
                      rules={[
                        {
                          required: true,
                          message: "please input Payment Mode",
                        },
                      ]}
                      // initialValue={PospQuotePost?.firstName }
                    >
                      <Select
                        placeholder="Payment Mode"
                        showSearch
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        // onChange={handleChange}
                        options={InsurerList?.map((p) => ({
                          key: p.id,
                          value: p.name,
                          label: p.name,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Cheque Number"
                      name="cheque_number"
                      rules={[
                        {
                          required: true,
                          message: "please input Cheque Number",
                        },
                      ]}
                      // initialValue={PospQuotePost?.firstName }
                    >
                      <Input
                        style={{ width: "100%" }}
                        placeholder="Cheque Number"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Customer Name"
                      name="customer_name"
                      rules={[
                        {
                          required: true,
                          message: "please input Customer Name",
                        },
                      ]}
                      // initialValue={PospQuotePost?.firstName }
                    >
                      <Input
                        style={{ width: "100%" }}
                        placeholder="Customer Name"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Customer Mobile"
                      name="customer_number"
                      rules={[
                        {
                          pattern: /^([0|+[0-9]{1,5})?([6-9][0-9]{9})$/,
                          message: "Invalid Mobile No",
                        },
                        { required: true, message: "Enter Mobile No" },
                      ]}
                    >
                      <Input
                        maxLength={10}
                        addonBefore={prefixSelector}
                        placeholder="Mobile Number"
                      ></Input>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Date of Birth"
                      name="customer_dob"
                      rules={[
                        {
                          required: true,
                          message: "Please select DOB",
                        },
                      ]}
                      //   initialValue={PospQuotePost?.owner_dob ? moment(PospQuotePost?.owner_dob) : null}
                    >
                      <DatePicker
                        style={{ width: "100%", padding: "8px" }}
                        disabledDate={disabledDate}
                        defaultPickerValue={getDefaultPickerValue()}
                        format="YYYY-MM-DD"
                        placeholder="YYYY-MM-DD"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Policy Start Date"
                      name="policy_start_date"
                      rules={[
                        {
                          required: true,
                          message: "Please select start date",
                        },
                      ]}
                      // initialValue={PospQuotePost?.owner_dob ? moment(PospQuotePost?.owner_dob) : null}
                    >
                      <DatePicker
                        style={{ width: "100%", padding: "8px" }}
                        disabledDate={disabledPolicyStart}
                        //   defaultPickerValue={getDefaultPickerValue()}
                        format="YYYY-MM-DD"
                        placeholder="YYYY-MM-DD"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Policy End Date"
                      name="policy_end_date"
                      rules={[
                        {
                          required: true,
                          message: "Please select end date",
                        },
                      ]}
                      // initialValue={PospQuotePost?.owner_dob ? moment(PospQuotePost?.owner_dob) : null}
                    >
                      <DatePicker
                        style={{ width: "100%", padding: "8px" }}
                        // disabledDate={disabledDate}
                        defaultPickerValue={getDefaultExpPicker()}
                        format="YYYY-MM-DD"
                        placeholder="YYYY-MM-DD"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Policy Number"
                      name="policy_number"
                      rules={[
                        { required: true, message: "Enter Policy Number" },
                      ]}
                      //   initialValue={vechicleData?.insurance_policy_number}
                    >
                      <Input placeholder="Enter Policy Number"></Input>
                    </Form.Item>
                  </Col>
                  {SubProdSelect === "Third party" || gvalue === "N" ? null : (
                    <>
                      <Col span={6}>
                        <Form.Item
                          label="Current No Claim Bonus(NCB)"
                          name="current_ncb"
                          // initialValue={QuickPost?.ncbvalue}
                          rules={[
                            {
                              required: true,
                              message: "Select No Claim Bonus",
                            },
                          ]}
                        >
                          <Select placeholder="NCB">
                            <Select.Option value="ZERO">0%</Select.Option>
                            <Select.Option value="TWENTY">20%</Select.Option>
                            <Select.Option value="TWENTY_FIVE">
                              25%
                            </Select.Option>
                            <Select.Option value="THIRTY_FIVE">
                              35%
                            </Select.Option>
                            <Select.Option value="FORTY_FIVE">
                              45%
                            </Select.Option>
                            <Select.Option value="FIFTY">50%</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                    </>
                  )}

                  <Col span={6}>
                    <Form.Item
                      label="Insurer Name"
                      name="current_insurer"
                      rules={[
                        {
                          required: true,
                          message: "Please select previous insurer",
                        },
                      ]}
                      //   initialValue={QuickPost?.previousInsurerCode}
                    >
                      <Select
                        placeholder="Select Insurer"
                        showSearch
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        // onChange={handleChange}
                        options={InsurerList?.map((p) => ({
                          key: p.id,
                          value: p.name,
                          label: p.name,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                  {SubProdSelect === "Third party" || gvalue === "N" ? null : (
                    <>
                      <Col span={6}>
                        <Form.Item
                          label="Own Damage Premium"
                          name="own_damage_premium"
                          rules={[
                            {
                              required: true,
                              message: "please input OD premium",
                            },
                          ]}
                        >
                          <Input
                            type="number"
                            style={{ width: "100%" }}
                            placeholder="Own Damage Premium"
                          />
                        </Form.Item>
                      </Col>
                      {gvalue === "N" ? null : (
                        <Col span={6}>
                          <Form.Item
                            label="Addon Premium"
                            name="addon_premium"
                            rules={[
                              {
                                required: true,
                                message: "please input Addon Premium",
                              },
                            ]}
                          >
                            <Input
                              type="number"
                              style={{ width: "100%" }}
                              placeholder="Addon Premium"
                            />
                          </Form.Item>
                        </Col>
                      )}
                    </>
                  )}

                  {SubProdSelect === "Standalone own damage" ||
                  gvalue === "N" ? null : (
                    <>
                      <Col span={6}>
                        <Form.Item
                          label="Basic TP Premium"
                          name="basic_tp_premium"
                          rules={[
                            {
                              required: true,
                              message: "please input Basic TP Premium",
                            },
                          ]}
                        >
                          <Input
                            type="number"
                            style={{ width: "100%" }}
                            placeholder="Basic TP Premium"
                          />
                        </Form.Item>
                      </Col>
                      {gvalue === "N" ? null : (
                        <Col span={6}>
                          <Form.Item
                            label="CPA Premium"
                            name="cpa_premium"
                            rules={[
                              {
                                required: true,
                                message: "please input CPA Premium",
                              },
                            ]}
                          >
                            <Input
                              type="number"
                              style={{ width: "100%" }}
                              placeholder="CPA Premium"
                            />
                          </Form.Item>
                        </Col>
                      )}
                    </>
                  )}
                  <Col span={6}>
                    <Form.Item
                      label="Net Premium"
                      name="net_premium"
                      rules={[
                        {
                          required: true,
                          message: "please input Net Premium",
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        style={{ width: "100%" }}
                        placeholder="Net Premium"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Toatl Premium"
                      name="total_premium"
                      rules={[
                        {
                          required: true,
                          message: "please input Total Premium",
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        style={{ width: "100%" }}
                        placeholder="Total Premium"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="policy_document"
                      label="Policy Document"
                      rules={[
                        {
                          required: true,
                          message: "Please Upload Policy Document",
                        },
                      ]}
                    >
                      <Upload {...props1} maxCount={1}>
                        <Button
                          type="primary"
                          className="upload-kyc-btn"
                          icon={<PlusOutlined />}
                        >
                          Upload
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item style={{ textAlign: "center" }}>
                  <Button type="primary" htmlType="submit" loading={loading}>
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </Spin>
      </section>
    </>
  );
}
